import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-054f6a90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product" }
const _hoisted_2 = { class: "product__title" }
const _hoisted_3 = { class: "product__main" }
const _hoisted_4 = { class: "product__left" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "product__right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString($props.product?.title), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_swiper, {
              class: "product__images",
              "slides-per-view": 1,
              modules: [$setup.Thumbs],
              thumbs: { swiper: $setup.thumbsSwiper }
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.product?.images, (image) => {
                  return (_openBlock(), _createBlock(_component_swiper_slide, {
                    class: "product__image",
                    key: image
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: image,
                        alt: $props.product?.title
                      }, null, 8, _hoisted_5)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["modules", "thumbs"]),
            _createVNode(_component_swiper, {
              modules: [$setup.Thumbs],
              "watch-slides-progress": "",
              onSwiper: $setup.setThumbsSwiper,
              "slides-per-view": 4,
              "space-between": 12,
              scrollbar: { draggable: true }
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.product?.images, (image) => {
                  return (_openBlock(), _createBlock(_component_swiper_slide, {
                    class: "product__thumb",
                    key: image
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: image,
                        alt: $props.product?.title
                      }, null, 8, _hoisted_6)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["modules", "onSwiper"])
          ]),
          _createElementVNode("div", _hoisted_7, _toDisplayString($props.product?.description), 1)
        ])
      ])
    ]),
    _: 1
  }))
}